/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DeviceInterfaceType = {
    None: 'None',
    PtwLegacy: 'PTWLegacy',
    PtwioT: 'PTWIoT',
    PtwLegacyIot: 'PTWLegacyIot'
} as const;
export type DeviceInterfaceType = typeof DeviceInterfaceType[keyof typeof DeviceInterfaceType];


export function DeviceInterfaceTypeFromJSON(json: any): DeviceInterfaceType {
    return DeviceInterfaceTypeFromJSONTyped(json, false);
}

export function DeviceInterfaceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeviceInterfaceType {
    return json as DeviceInterfaceType;
}

export function DeviceInterfaceTypeToJSON(value?: DeviceInterfaceType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the DeviceInterfaceType interface.
 */
 export function instanceOfDeviceInterfaceType(value: any): value is DeviceInterfaceType {
    return Object.values(DeviceInterfaceType).includes(value)
}

